export default __webpack_public_path__ + "static/media/hero-2-bg.3f9976ea.png";